import React from 'react';

import Range from '@atlaskit/range/range';

const RangeUncontrolledExample = (): React.JSX.Element => {
	return (
		<Range
			aria-label="uncontrolled range"
			step={1}
			onChange={(value) => console.log('new value', value)}
		/>
	);
};

export default RangeUncontrolledExample;
